import check from './Eo_circle_green_checkmark.svg.png';
import jewel from './10365928_10154171530055010_2090806117957215339_n.png'
import './ThankYouPage.css'
import jewelryLogo from './Logo_220x151.png'
export default function ThankYouPage() {
    return (
      <div className = "container">
        <div className = "background">  
        </div>
          <h1 className = "header-1">Thank You From The</h1>
          <div className = "img-container">
          <img className = "img-size" src = {jewelryLogo}></img>
      
        <div/>

      </div>
      </div>
         

    );
  }